<template>
    <el-container>
        <el-main>
            <el-row type="flex" align="middle">
                <el-col :span="3" class="order-title"><i class="el-icon-s-order"></i>我的订单</el-col>
                <span style="margin: 0 40px 0 0"><el-divider direction="vertical"></el-divider></span>
                <el-col :span="10">
                    <el-radio-group v-model="orderStatus" size="medium" @change="getList(1)">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button label="0">未支付</el-radio-button>
                        <el-radio-button label="1">已完成</el-radio-button>
                        <el-radio-button label="2">待退款</el-radio-button>
                        <el-radio-button label="3">已失效</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="6" :push="4">
                    <el-input prefix-icon="el-icon-search" v-model="orderSearchVal" placeholder="请输入订单名称或编号" size="medium" @clear="getList(1)" clearable>
                        <el-button slot="append" icon="el-icon-search" size="small" @click="searchOrder"></el-button>
                    </el-input>
                </el-col>
            </el-row>
            <div :v-loading="loading">
                <el-card class="box-card" shadow="hover" v-if="orderList" v-for="(order, index) in orderList" :key="index">
                    <el-row type="flex" justify="space-between">
                        <el-col :span="8" style="font-size: 15px;color: #606266;">订单编号 : {{order.id}}</el-col>
                        <el-col :span="4" style="font-size: 14px;color: #909399;text-align: center">{{order.createdTime}}</el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <el-col :span="3">
                            <a href="#" @click="goToCourse(order.courseId)"><el-image style="width: 120px" :src="order.courseImage" fit="contain"></el-image></a>
                        </el-col>
                        <el-col :span="11" style="margin-left: 15px">
                            <el-link :underline="false" style="font-size: 17px;font-weight: bold;margin-left: -8px" @click="goToCourse(order.courseId)">
                                【{{order.courseType === 'O' ? '技术人员培训学习' : '技术人员宣贯学习'}}】
                                 {{order.courseName}}
                            </el-link>
                            <div style="font-size: 15px;color: #909399;margin-top: 12px">{{order.courseShortDesc}}</div>
                        </el-col>
                        <el-col :span="4" :offset="1" style="margin-top: 33px">
                            <span style="color: #909399;">实付 : </span><span style="color: #F56C6C;font-size: 19px">¥{{order.totalPrice}}</span>
                        </el-col>
                        <el-col :span="3" :offset="1" style="margin-top: 23px;text-align: center">
                            <div v-if="order.status === '0'">
                                <el-button type="primary" round @click="pay(order.id, order.courseId)">立即支付</el-button>
                                <el-link type="info" style="font-size: 13px" @click="cancelOrder(order.id)">取消订单</el-link>
                            </div>
                            <div v-else-if="order.status === '1'">
                                <el-tag type="success" effect="dark" disable-transitions>支付成功</el-tag>
                                <el-link type="info" style="font-size: 13px" @click="applyRefund(order.id, order.status)">申请退款</el-link>
                            </div>
                            <div v-else-if="order.status === '2'">
                                <el-tag type="warning" effect="dark" disable-transitions>待退款</el-tag>
                            </div>
                            <div v-else-if="order.status === '3'">
                                <el-tag type="info" disable-transitions>已失效</el-tag>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
                <div v-if="orderList.length > 0" style="text-align: center; margin: 30px 0 20px">
                    <el-pagination
                            background
                            layout="prev, pager, next, total"
                            :total="pageInfo.totalRecordCount"
                            :page-size.sync="pageInfo.pageSize"
                            :current-page.sync="pageInfo.pageNo"
                            @current-change="getList">
                    </el-pagination>
                </div>
            </div>
                <!--无订单信息时-->
            <div v-if="orderList.length <= 0" class="empty-order-title">
                <div class="order-content">
                <i class="el-icon-warning-outline"></i>
                暂无任何{{orderStatus === '' ? '' :
                                    orderStatus === '0' ? '未支付的' :
                                        orderStatus === '1' ? '已完成的' :
                                            orderStatus === '2' ? '待退款' : '已失效的'}}订单
                </div>
            </div>
        </el-main>

        <!--退款dialog-->
        <el-dialog title="申请退款" :visible.sync="openRefundDialog" width="600px" :lock-scroll="false" @close="refundReason=''">
            <el-steps :active="refundStepIndex" finish-status="success" align-center process-status="process">
                <el-step title="填写退款原因"></el-step>
                <el-step title="退款申请审核中"></el-step>
                <el-step title="收到退款结果通知"></el-step>
            </el-steps>
            <el-row type="flex" justify="center" style="margin-top: 30px" :gutter="10" v-if="refundStepIndex === 0">
                <el-col :span="18">
                    <el-input type="textarea" placeholder="请填写退款原因" v-model="refundReason" maxlength="80" rows="3" show-word-limit clearable/>
                </el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 20px">
                <el-col :span="5"><el-button type="primary" @click="submitRefund" style="width: 100%">确定</el-button></el-col>
            </el-row>
        </el-dialog>
    </el-container>
</template>

<script>
    export default {
        name: "MyOrder",
        data() {
            return {
                orderStatus: '',
                orderList: [],
                orderSearchVal: '',
                loading: false,
                pageInfo: {
                    totalRecordCount: 0,
                    pageSize: 5,
                    pageNo: 1
                },

                openRefundDialog: false,
                currentRefundOrderId: '',
                refundReason: '',
                refundStepIndex: 0,
            }
        },
        methods: {
            goToCourse(courseId) {

            },
            searchOrder() {
                if (this.orderSearchVal) {
                    this.getList(1);
                } else {
                    this.$message.error('请输入订单名称或编号 !');
                }
            },
            cancelOrder(orderId) {
                this.$confirm('确定要删除该订单吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error',
                    lockScroll: false
                }).then(async () => {
                    const { success } = await this.$http.post('/business/web/order/cancelOrder?orderId=' + orderId);
                    if (success) {
                        this.getList(1);
                        this.$message({ type: 'success', message: '取消订单成功!' });
                    }
                }).catch(() => { });
            },
            pay(orderId, courseId) {
                this.$router.push({ name: 'OrderPay', params: { orderId: orderId, courseId: courseId } });
            },
            applyRefund(orderId, status) {
                /*if (status === '2')  { //退款中
                    this.refundStepIndex = 1;
                } else if (status === '3')  { //退款成功
                    this.refundStepIndex = 3;
                    this.refundResult = '退款成功';
                } else if (status === '4') { //退款失败
                    this.processStatus = 'error';
                    this.refundStepIndex = 3;
                    this.refundResult = '退款失败';
                }*/
                this.openRefundDialog = true;
                this.currentRefundOrderId = orderId;
            },
            submitRefund() {
                if (!this.refundReason) {
                    this.$message.error('请填写退款原因 !'); return;
                }
                this.$confirm('是否确定申请退款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    const params = {
                        id: this.currentRefundOrderId,
                        refundReason: this.refundReason
                    };
                    const { success } = await this.$http.post('/business/web/order/applyRefund', params);
                    if (success) {
                        this.getList(1);
                        this.$message({ type: 'success', message: '申请退款成功!' });
                    }
                    this.openRefundDialog = false;
                }).catch(() => {
                    this.openRefundDialog = false;
                });
            },
            async getList(pageNo) {
                this.loading = true;
                const params = {
                    page: pageNo ? pageNo : this.pageInfo.pageNo,
                    size: this.pageInfo.pageSize,
                    orderSearchVal: this.orderSearchVal,
                    orderStatus: this.orderStatus,
                };
                const { content: { records, total } } = await this.$http.post('/business/web/order/list', params);
                this.orderList = records;
                this.pageInfo.totalRecordCount = total;
                this.loading = false;
            }
        },
        created() {
            this.getList(1);
        }
    }
</script>

<style lang="scss" scoped>
    .el-container {
        width: 1100px;
        margin: 0 auto;
    }

    .order-title {
        font-size: 18px;
        font-weight: bold;
        padding-left: 10px;
    }

    .empty-order-title {
        padding-top: 10px;
        text-align: center;
        color: #C0C4CC;
    }

    .order-content {
        width: 90%;
        margin: 10px auto 0;
        padding: 40px;
        border: 1px solid #EBEEF5;
        border-radius: 6px;
    }

    .el-card {
        height: 185px;
        margin: 10px 0;
        border: 1px solid #E4E7ED;
    }

    /deep/ .el-dialog__body {
        padding: 10px 20px 40px;
    }

     i {
         margin-right: 5px;
     }

    .el-divider {
        margin: 15px 0;
    }

    .el-tag {
        height: 38px;
        width: 95px;
        line-height: 36px;
        font-size: 14px;
    }
</style>
